const mcpApiEndPoints = {
  mcpServers: '/api/mcp-servers',
  toolsCatalog: '/api/tools',
  toolsUpdate: '/api/tools/update',
  tenantToolsList: '/api/capabilities/tools/list',
  tenantToolsToggle: '/api/capabilities/tools/toggle',
  tenantToolsUpsert: '/api/capabilities/tools/upsert',
  bindingsList: '/api/capabilities/bindings/list',
  bindingsGet: '/api/capabilities/bindings/get',
  assignmentsList: '/api/capabilities/assignments/list',
  assignmentsSet: '/api/capabilities/assignments/set',
  serversToggle: '/api/capabilities/servers/toggle',
  mcpToggle: '/api/capabilities/mcp/toggle',
};

export default mcpApiEndPoints;
